import { Filter, OrderByCondition } from "@/types/filter.type";
import { Pagination } from "@/types/pagination.type";

import axios from "./api";
import { responseHandlerDefault } from "./../utils/handler.util";
import { IssueDiagnosis } from "@/types/issueMonitoring.type";

export const getIssueDiagnosis = (
  page?: number,
  size?: number,
  filter?: Filter,
  order?: OrderByCondition
): Promise<Pagination<IssueDiagnosis>> => {
  const params: {
    page?: number;
    size?: number;
    fromDate?: string | undefined;
    toDate?: string | undefined;
    filter?: Filter;
    order?: OrderByCondition;
  } = {};
  if (page) {
    params.page = page;
  }
  if (size) {
    params.size = size;
  }

  if (filter) {
    params.filter = filter;
  }
  if (order) {
    params.order = order;
  }

  return axios.get(`/issuediagnosis/`, { params }).then(responseHandlerDefault);
};
